import React from 'react';
import { SearchIcon } from 'assests/GmsIcons';

type SearchBarProps = {
    value: string;
    onChange: (value: string) => void;
};

const SearchBar = ({ value, onChange }: SearchBarProps) => {
    return (
        <div className="tw-w-96 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-outline tw-outline-1 tw-outline-offset-[-1px] tw-outline-stone-300 tw-inline-flex tw-justify-center tw-items-center tw-gap-2.5">
            <input
                type="text"
                className="tw-self-stretch text-sm tw-font-normal tw-flex-1 tw-justify-start tw-text-slate-500 tw-text-sm tw-leading-tight tw-bg-transparent tw-border-none tw-outline-none"
                placeholder="Search"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
            <div className="tw-flex tw-items-center">
                <SearchIcon />
            </div>
        </div>
    );
};

export default SearchBar;